import { h } from 'preact'
import { useRef } from 'preact/hooks'
import MonogramInput from './monogram-input'

export default function UpsellMonogramInput({ monogramStraight, callback }) {
  const submitButton = useRef()

  const handleSubmit = (e) => {
    e.stopPropagation()
    const properties = {}
    const formData = new FormData(e.target)
    const re = /properties\[(.*)\]/
    for (const pair of formData.entries()) {
      const match = re.exec(pair[0])
      if (match) {
        properties[match[1]] = pair[1]
      }
    }

    callback({ properties })

    // If you pass "prependInputNames={false}" to the MonogramInput below, you should be able to replace the above with
    //   e.stopPropagation()
    //   const properties = Object.fromEntries(new FormData(e.target))
    //   callback({ properties })
    // However, I want to wait until Jordann has a monogram upsell to test this first.
  }

  return (
    <form onSubmit={handleSubmit}>
      <h3 class="micromodal--title">Set Monogram</h3>
      <MonogramInput tagline="Monograms require 20-25 business days for processing and delivery" addToCart={submitButton.current}
                     monogramStraight={monogramStraight} />
      <input ref={submitButton} type="submit" name="button" value="Add To Cart" />
    </form>
  )
}
